export function getOwnProperty(o, key) {
  return Object.prototype.hasOwnProperty.call(o, key) ? o[key] : undefined;
}